var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "StoryTitle" } }, [
    _c(
      "div",
      {
        staticClass:
          "block-title-container d-flex flex-row justify-content-center align-items-center",
      },
      [
        _c(
          "IconButton",
          {
            attrs: {
              "on-click": function () {
                return _vm.$router.push("/chatbot/stories")
              },
            },
          },
          [
            _c("span", { staticClass: "material-icons cb-back-button" }, [
              _vm._v(" chevron_left "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          ref: "editStoryName",
          attrs: { placeholder: _vm.$t("chatbotv2.typeStoryTitle") },
          domProps: { value: _vm.storyName },
          on: {
            input: function ($event) {
              _vm.storyName = $event.target.value
            },
            blur: function ($event) {
              return _vm.updateName()
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }